import { Banner, Text } from '@betterment/samba-react';
import { HtmlContent } from '@betterment/shared-components';

import { messageBannerVariant } from './data';
import MessageCta from './message-cta';

import { Message } from '../../graphql/schema';

interface MessageBoxBannerProps {
  message: Message;
  handleCloseMessage: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const MessageBanner: React.FC<MessageBoxBannerProps> = ({ message, handleCloseMessage }) => {
  const variant = messageBannerVariant[message.style];
  return (
    <Banner variant={variant} css={{ width: '100%' }}>
      <Banner.Content>
        <Text as="p" color="text">
          <HtmlContent documentFragment={message.body} as="span" />
          {message.cta && <MessageCta cta={message.cta} />}
        </Text>
      </Banner.Content>
      {message.isDismissible && <Banner.Close onClick={handleCloseMessage} />}
    </Banner>
  );
};

export default MessageBanner;
